import React, { useState } from 'react';
import './Questions.scss';
import { ReactComponent as Plus } from '../Assets/icons/PLUS.svg';
import { ReactComponent as Minus } from '../Assets/icons/Minus-white.svg';


interface Question {
    title: string;
    questions: QuestionItem[];
}

interface QuestionProps {
    data: Question;
    index: number;
}

interface QuestionItem {
    question: string;
    answer: string;
}

interface QuestionItemProps {
    id?: string;
    question: string;
    answer: JSX.Element;
}


export const QuestionItem = ({ id, question, answer }: QuestionItemProps): JSX.Element => {
    const [expand, setExpand] = useState(false);

    return <div className='questions-box-item-wrapper' id={id}>
        <div className='questions-box-item-question-wrapper'
             style={{ backgroundColor: expand && '#000000', color: expand && '#ffffff' }}
             onClick={() => setExpand(!expand)}>
            <span className='questions-box-item-question-text'>{question}</span>
            {!expand ?
                <Plus className='questions-box-item-question-icon' />
                :
                <Minus className='questions-box-item-question-icon'
                       fill={'#ffffff'}
                />}
        </div>

        <span
            className={`questions-box-item-answer-wrapper ${expand ? 'questions-box-item-answer-wrapper-expand' : ''}`}>
            {answer}
        </span>

        <div className='questions-item-box-divider' />
    </div>;
};

const Questions = ({ id, title, index, children }: any): JSX.Element => {
    return (
        <div className='questions-container' style={{ marginTop: index !== 0 && '50px' }} id={id}>

            <div className='questions-wrapper'>
                <span className='questions-box-title'>{title}</span>
                <div className='questions-box-divider' />

                {children}
                {/*{data.questions.map((data, index) => {*/}
                {/*    return <QuestionItem key={index} data={data} index={index} />;*/}
                {/*})}*/}
            </div>

        </div>
    );
};

export default Questions;